import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { LoadState } from '../../pages/store/types';
import { ICombinedBalance } from '../../services/client/types';
import clientSvc from '../../services/client/clientSvc';

type CombinedBalanceState = LoadState<ICombinedBalance>;

export const initialState: CombinedBalanceState = {
  error: '',
  loading: false,
  data: null,
};
const fetchCombinedBalance = createAsyncThunk(
  'fetchCombinedBalance',
  async (enterpriseId: string) => clientSvc.getCombinedBalance(enterpriseId)
);

export const combinedBalanceSlice = createSlice({
  name: 'combinedBalance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCombinedBalance.pending, (state) => {
      state.loading = true;
      state.error = '';
      state.data = null;
    });
    builder.addCase(
      fetchCombinedBalance.fulfilled,
      (state, { payload: combinedBalance }) => {
        state.loading = false;
        state.data = combinedBalance;
        state.error = '';
      }
    );
    builder.addCase(fetchCombinedBalance.rejected, (state) => {
      state.loading = false;
      state.data = null;
      state.error = 'ERROR';
    });
  },
});

export { fetchCombinedBalance };
export default combinedBalanceSlice.reducer;
